<div class="modal-header">
    <h5 class="modal-title">Chi Tiết Mã QR</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <img [src]="retrievedImage">
    <p><strong>ISBN:</strong> {{ qrCode?.isbn }}</p>
    <p><strong>Chiều Rộng:</strong> {{ qrCode?.width }} cm</p>
    <p><strong>Chiều Cao:</strong> {{ qrCode?.height }} cm</p>
    <p><strong>Lề:</strong> {{ qrCode?.margin }} cm</p>
</div>

<div class="modal-footer">
<button type="button" class="btn btn-outline-success" (click)="closeModal()">
            <i class="fas fa-paper-plane"></i> Đóng
        </button>
</div>

